import { render, staticRenderFns } from "./OperaIntegralShopMoneyWindow.vue?vue&type=template&id=623577d6&scoped=true&"
import script from "./OperaIntegralShopMoneyWindow.vue?vue&type=script&lang=js&"
export * from "./OperaIntegralShopMoneyWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaIntegralShopMoneyWindow.vue?vue&type=style&index=0&id=623577d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623577d6",
  null
  
)

export default component.exports